var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlTouristOutlined = function SvgHtlTouristOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.688 12.986a1.694 1.694 0 0 1-1.693-1.693L1 6.493a1.694 1.694 0 0 1 1.693-1.692h1.471l1.044-1.567a.5.5 0 0 1 .417-.222h4.723a.5.5 0 0 1 .416.222l1.045 1.567h1.5a1.7 1.7 0 0 1 1.693 1.693l-.005 4.8a1.7 1.7 0 0 1-1.693 1.693l-10.616-.001ZM2 6.498l-.005 4.8a.694.694 0 0 0 .693.693h10.62a.694.694 0 0 0 .692-.693l.005-4.8a.693.693 0 0 0-.693-.692H11.54a.5.5 0 0 1-.416-.222L10.08 4.017H5.891L4.846 5.584a.5.5 0 0 1-.416.222H2.691a.693.693 0 0 0-.69.692Zm3.51 2a2.5 2.5 0 1 1 5-.004 2.5 2.5 0 0 1-5 .006v-.002Zm1 0a1.5 1.5 0 1 0 .114-.573 1.5 1.5 0 0 0-.114.575v-.002Z"
  })));
};
export default SvgHtlTouristOutlined;